<template>
  <v-container>
    <v-card
      class="mx-auto"
      outlined
    >
      <v-card-title class="mx-0 pa-0">
        <h4 class="ma-2">{{ $t('help.title') }}</h4>
      </v-card-title>
      <v-expansion-panels v-model="helpPanel" accordion >
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('help.overviewtitle') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.overview' )}}
            </p>
            <p>
              {{ $t('help.overview2' )}}
            </p>
            <p>
              {{ $t('help.overview3' )}}
            </p>
            <p>
              {{ $t('help.overview4' )}}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('app.status') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.status' )}}
            </p>
            <p>
              {{ $t('help.score' )}}
            </p>
            <v-row>
              <v-col cols="3" class="align-self-center">
                <v-btn color="green" fab small>
                  <v-icon>mdi-emoticon-happy-outline</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="9">
                {{ $t('help.riskok')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="align-self-center">
                <v-btn color="orange" fab small>
                  <v-icon>mdi-emoticon-neutral-outline</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="9">
                {{ $t('help.riskmed')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="align-self-center">
                <v-btn color="red" fab small>
                  <v-icon>mdi-emoticon-sad-outline</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="9">
                {{ $t('help.riskhigh')}}
              </v-col>
            </v-row>
            <p>
              {{ $t('help.persons' )}}
            </p>
            <p>
              {{ $t('help.health' )}}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('app.requests') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.requests' )}}
            </p>
            <v-row>
              <v-col cols="2">
                <v-icon disabled>mdi-account-clock-outline</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.reqclock')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon color="green">mdi-check-circle-outline</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.reqchecked')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon color="red">mdi-cancel</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.reqrejected')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon color="red">mdi-close-circle</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.reqdelete')}}
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('help.conncreatetitle') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.conncreate' )}}
            </p>
            <p>
              {{ $t('help.conncreate2' )}}
            </p>
            <p>
              {{ $t('help.conncreate3' )}}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('help.connreceivetitle') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.connreceive1' )}}
            </p>
            <p>
              {{ $t('help.connreceive2' )}}
            </p>
            <v-row>
              <v-col cols="2">
                <v-icon>mdi-account-multiple</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.conntypeperm')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon>mdi-clock-outline</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.conntypetrans')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon>mdi-account-off-outline</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.conntypevirtual')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-icon>mdi-alien-outline</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.conntypeforeign')}}
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('app.connections') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ $t('help.connections')}}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('app.locations') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.locations' )}}
            </p>
            <p>
              {{ $t('help.locations2' )}}
            </p>
            <v-row>
              <v-col cols="2">
                <v-icon>mdi-eye-check-outline</v-icon>
              </v-col>
              <v-col cols="10">
                {{ $t('help.loceye')}}
              </v-col>
            </v-row>
            <p>
              {{ $t('help.locations3' )}}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t('app.graph') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <p>
              {{ $t('help.graph' )}}
            </p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-actions>
        <a href="https://www.meeconn.cz">https://www.meeconn.cz</a>
        <v-spacer></v-spacer>
        <v-btn color="primary" to="/">{{ $t('app.btn.ok') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'Help',
  data: () => ({
    helpPanel: 0,
  }),
  mounted() {
    if (this.$route.params.section) {
      this.helpPanel =  parseInt(this.$route.params.section)
    }
  }
}
</script>
